"use client";

import { useSession } from "next-auth/react";
import { FC, useEffect, useState } from "react";

import GuidedToolCard from "@/components/GuidedToolLauncher/GuidedToolCard";
import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import useIsSaleScreen from "@/hooks/useIsSaleScreen";
import { GuidedToolCardItem, GuidedToolLauncherProps } from "@/types";

import "./GuidedToolLauncher.css";

const GuidedToolLauncher: FC<GuidedToolLauncherProps> = ({ entry }) => {
  const { title, guestCards, loggedInCards, backgroundColor, secondaryTitle, cta } = entry;
  const { data: session } = useSession();

  const [cards, setCards] = useState<GuidedToolCardItem[]>();
  const isSo = useIsSaleScreen();

  useEffect(() => {
    setCards(session?.user ? loggedInCards : guestCards);
  }, [session?.user, loggedInCards, guestCards]);

  if (isSo) return;

  return (
    <div className="guided-tool-starting-point py-xxl flex items-center" style={{ backgroundColor: backgroundColor }}>
      <div className="w-22\/24 md:w-20\/24 mx-auto py-l ">
        <h2 className="font-primary uppercase text-center text-m md:text-xl mt-xs pb-xl md:pb-xxl">{title}</h2>
        <div className="grid grid-cols-2 gap-m md:gap-l md:grid-cols-4 pb-xl">
          {cards &&
            cards.map((card, i) => {
              return <GuidedToolCard key={i} card={card} />;
            })}
        </div>
        {secondaryTitle ||
          (cta && (
            <div className="text-center">
              {secondaryTitle && <h3 className="font-primary uppercase font-medium md:font-normal text-m md:text-l md:pt-xl ">{secondaryTitle}</h3>}
              {cta && (
                <Button
                  rounded
                  size={ButtonSize.MEDIUM}
                  theme={ButtonTheme.BLACK}
                  href={cta.link}
                  variant={ButtonVariant.PRIMARY}
                  customClass="inline-flex mt-xl font-medium"
                >
                  {cta.label}
                </Button>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default GuidedToolLauncher;
